// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__bzAr5","info":"Note_info__2JN87","note":"Note_note__3fqi4","actions":"Note_actions__37or4"};